import { useMemo } from 'react';

import { measureSms } from './measureSms';
import { MeasureSmsOptions, SmsMeasurement } from './measureSms.types';

/**
 * Represents the memoizing react wrapper around {@link measureSms}. It
 * depends on the options one by one rather than on the object, so that a caller
 * passing a fresh object literal every render does not recalculate every
 * keystroke.
 */
export const useSmsMeasurement = (
  text: string,
  { limit, reservedLength, placeholderPattern }: MeasureSmsOptions,
): SmsMeasurement =>
  useMemo(
    () => measureSms(text, { limit, reservedLength, placeholderPattern }),
    [text, limit, reservedLength, placeholderPattern],
  );
